import SessionService from '_services/common/sessionService';
import Axios from 'axios';

const axiosHeader = () => {
  const token = SessionService.getLocalData('_token');

  if (token) {
    Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete Axios.defaults.headers.common.Authorization;
  }
};

export default axiosHeader;
